import { StoryblokComponent } from '@storyblok/react';

import { useFormBuilderContext } from '../hooks/useFormBuilderContext';
import { FormBuilderBlockProps } from './FormBuilderBlock.types';

export const FormBuilderBlock = (props: FormBuilderBlockProps) => {
  const { blok } = props;
  const { showCondition, key, value, body } = blok;

  const { keyValues } = useFormBuilderContext();

  const content = body.map((blokData) => (
    <StoryblokComponent blok={blokData} key={blokData._uid} />
  ));

  if (
    showCondition === 'always' ||
    (showCondition === 'keyHasAnyValue' && Boolean(keyValues[key])) ||
    (showCondition === 'keyHasSpecificValue' && keyValues[key] === value)
  ) {
    return <>{content}</>;
  }

  return null;
};
